import { SearchOutlined } from '@ant-design/icons'
import { useDebounce } from 'ahooks'
import { Divider, Input, List, Spin, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useGetFavoredKnowledgeGroupsQuery, useGetKnowledgePostsQuery } from '@/generated/graphql'

import { KnowledgeCard } from './knowledge-card/knowledge-card.component'
import { KnowledgeGroupFavorCard } from './knowledge-card/knowledge-group-favor-card.component'
import s from './knowledge.module.less'

export const KnowledgeUserPage: React.FC = () => {
  const favorCount = 4
  const { t } = useTranslation()
  const [search, setSearch] = React.useState<string>('')
  const debouncedSearch = useDebounce(search, { wait: 500 })

  const { data } = useGetFavoredKnowledgeGroupsQuery()

  const { data: searchData, loading } = useGetKnowledgePostsQuery({
    skip: !debouncedSearch,
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'no-cache',
    variables: {
      search: debouncedSearch,
      pagination: {
        last: 6,
      },
    },
  })

  if (!data) {
    return null
  }

  const favoredKnowledgeGroups = data.viewer.favoredKnowledgeGroups ? data.viewer.favoredKnowledgeGroups.slice() : []
  const favoredKnowledgeGroupCard = favoredKnowledgeGroups.map((favoredKnowledgeGroup) => (
    <KnowledgeGroupFavorCard key={favoredKnowledgeGroup.knowledgeGroupId} knowledgeGroup={favoredKnowledgeGroup} />
  ))

  const knowledgePosts = searchData
    ? searchData.knowledge.posts.edges
        .slice()
        .reverse()
        .map(({ node }) => node)
    : []

  const loadingComponent = (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <Spin size='large' delay={300}></Spin>
    </div>
  )

  const header = (
    <div className={s.header}>
      <div style={{ display: 'flex', alignItems: 'center', height: 32 }}>
        <Typography.Title style={{ marginBottom: 0 }} level={4}>
          {t('knowledge.favor')}
        </Typography.Title>
      </div>
    </div>
  )

  const content = (
    <div className={s.innerContent}>
      {favoredKnowledgeGroupCard.length === favorCount
        ? favoredKnowledgeGroupCard
        : favoredKnowledgeGroupCard.concat([<KnowledgeGroupFavorCard key={0} />])}
    </div>
  )

  const searchInput = (
    <div className={s.search}>
      <Input
        size='large'
        prefix={<SearchOutlined />}
        placeholder={t('knowledge.search')}
        onChange={(e) => setSearch(e.target.value)}
      />
    </div>
  )

  const searchResult = (
    <List
      dataSource={knowledgePosts}
      renderItem={(knowledgePost) => (
        <KnowledgeCard key={knowledgePost.knowledgePostId} knowledgePost={knowledgePost} />
      )}
    />
  )

  return (
    <div className={s.knowledges}>
      {header}
      {content}
      <Divider />
      {searchInput}
      {}
      {loading ? loadingComponent : knowledgePosts.length > 0 && searchResult}
    </div>
  )
}
